import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox, RadioButton } from "@progress/kendo-react-inputs";
import { useState } from "react";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Whisper, Tooltip } from "rsuite";
import { AnswerOption, Question } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Confirm } from "../confirm";
import { useIntl } from "react-intl";

export interface OptionsProps {
  radioOrCheckBox: boolean;
  makeBig: boolean;
  answerOption: AnswerOption;
  lastQuestion: boolean;
  questionId: string;
}

export function Options(props: OptionsProps) {
  const tooltip = (
    <Tooltip className="bg-mk-primary-bright">
      <div className="font-bold text-sm">{props.answerOption.optionFlag}</div>
      <div>{props.answerOption.optionRationale}</div>
    </Tooltip>
  );

  return (
    <div className=" w-52 flex flex-row space-x-1 items-center">
      {props.radioOrCheckBox ? (
        <RadioButton
          defaultChecked={
            props.answerOption.optionFlag === "CORRECT" ? true : false
          }
          disabled={!props.makeBig}
          name={props.questionId}
        />
      ) : (
        <Checkbox />
      )}

      <div className="break-words w-40 text-xs">
        {props.answerOption.optionVal}
      </div>

      <Whisper
        placement={props.lastQuestion ? "left" : "right"}
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <FontAwesomeIcon
          icon={["far", "fa-circle-info" as IconName]}
          className="h-3.5 w-3.5 text-mk-primary-bright hover:cursor-pointer"
        />
      </Whisper>
    </div>
  );
}

export interface ViewAssementCardProps {
  showCardMenuBar: boolean;
  question: Question;
  lastQuestion: boolean;
}

export function ViewAssementCard(props: ViewAssementCardProps) {
  const intl = useIntl();
  const [radioOrCheckBox, setRadioOrCheckBox] = useState<boolean>(true);
  const [questionDetail, setQuestionDetail] = useState<Question>(
    props.question
  );
  const [wantToDelete, setWantToDelete] = useState<boolean>(false);

  return (
    <div className="bg-mk-primary-20 w-52  flex flex-col justify-between rounded-xl shadow-md">
      {wantToDelete && (
        <Dialog className="alertDialogue">
          <Confirm
            className=""
            description={`${intl.formatMessage({
              id: "courses.viewAssessmentCard.deleteChapter",
            })}`}
            failureText={`${intl.formatMessage({
              id: "users.cohortDisplay.cancel",
            })}`}
            successText={`${intl.formatMessage({
              id: "users.cohortList.deletionSuccess",
            })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            backgroundColor={"mk-orange"}
            onFailure={() => setWantToDelete(false)}
            onSuccess={() => {
              setWantToDelete(false);
            }}
          />
        </Dialog>
      )}

      <div className=" w-full cardHeight overflow-y-auto  overflow-x-hidden pt-2 px-2 space-y-2">
        <div className="break-words w-full font-semibold text-sm">
          {props.question.question}
        </div>
        {questionDetail.answerOptions.map((ele, i) => {
          return (
            <Options
              questionId={questionDetail.quesId}
              key={i}
              lastQuestion={props.lastQuestion}
              answerOption={ele}
              radioOrCheckBox={radioOrCheckBox}
              makeBig={props.showCardMenuBar}
            />
          );
        })}
      </div>

      {props.showCardMenuBar && (
        <div className="w-full pb-4 flex items-center mt-1 justify-center space-x-1">
          <FontAwesomeIcon
            icon={["far", "fa-pen" as IconName]}
            className="h-4 w-4 text-mk-primary-bright hover:cursor-pointer"
          />
          {/* <FontAwesomeIcon
            onClick={() => {
              setWantToDelete(true);
            }}
            icon={["far", "fa-trash" as IconName]}
            className="h-4 w-4 text-mk-primary-bright hover:cursor-pointer "
          /> */}

          <FontAwesomeIcon
            onClick={() => {
              setWantToDelete(true);
            }}
            icon={["far", "fa-trash" as IconName]}
            className="h-4 w-4 text-mk-primary hover:text-mk-primary-bright hover:cursor-pointer"
          />

          <FontAwesomeIcon
            icon={[
              "fas",
              `${
                radioOrCheckBox ? "fa-circle-check" : "fa-circle-dot"
              }` as IconName,
            ]}
            className="h-4 w-4 text-mk-primary-bright hover:cursor-pointer"
            onClick={() => setRadioOrCheckBox(!radioOrCheckBox)}
          />
        </div>
      )}
    </div>
  );
}
